// @unocss-include
const layout = () => import('@/layout/index.vue')
const routes = [
  {
    path: '/verification',
    name: 'Verification',
    component: layout,
    redirect: '/verification/index',
    meta: {
      title: '信息核查',
      roles: [1],
      icon: 'i-menu:verification',
      category: 'optimize'
    },
    sort: 20,
    children: [
      {
        path: 'index',
        name: 'VerificationIndex',
        component: () => import('@/views/Verification/Index.vue'),
        meta: {
          title: '信息核查',
          i18Key: 'router.user.verification.index',
          icon: 'i-menu:verification',
          roles: [1],
          headerConditions: ['brand']
        }
      }
    ]
  }
]
export default routes
